module.exports = __webpack_public_path__ + "img/ICON_List_door_azul@6x.591adbaa.png";